import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { auth } from "./utils/firebase.js";
import * as Sentry from "@sentry/browser";
import "./assets/index.css";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
      logErrors: true
    }),
    new Integrations.BrowserTracing()
  ],
  tracesSampleRate: 1
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

auth.onAuthStateChanged(user => {
  // Update the store state
  store.dispatch("setUser", user);
});
